import { createSlice } from "@reduxjs/toolkit";

export const RefundSlice = createSlice({
  name: "Refund",
  initialState: {
    RefundList: [],
    RefundLoading: false,
  },
  reducers: {
    GetRefundHistory: (state) => {
      state.RefundLoading = true;
    },
    SetRefundHistory: (state, action) => {
      state.RefundList = action.payload;
      state.RefundLoading = false;
    },
  },
});

export const { GetRefundHistory, SetRefundHistory } = RefundSlice.actions;

export default RefundSlice.reducer;
